export const areItemsEqual = (item1, item2) => {
	if (item1.itemId !== item2.itemId) return false
	if (item1.priceIndex !== item2.priceIndex) return false
	const subItemKeys1 = (item1.items || []).map(s => `${s.itemId}:${s.quantity}`).sort()
	const subItemKeys2 = (item2.items || []).map(s => `${s.itemId}:${s.quantity}`).sort()
	if (subItemKeys1.length !== subItemKeys2.length) return false
	return subItemKeys1.every((key, i) => key === subItemKeys2[i])
}
